var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 250 190",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke-width:0px;}.cls-1,.cls-2,.cls-3{fill:none;}.cls-2{stroke:#e8ba3a;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-4{clip-path:url(#clippath);}.cls-3{stroke:#193c34;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.414931983366841,
    y: 4.84707523549514,
    width: 237.17013603326632,
    height: 180.30584952900972
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g649"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path651",
    className: "cls-3",
    d: "m229.581700042050215,133.898422244006724v8.430059270909624c0,1.949321815180156-1.5802375575513,3.529559372731455-3.529559372729636,3.529559372731455h-64.698593116350821c-1.949321815169242,0-3.529559372718722-1.5802375575513-3.529559372718722-3.529559372731455v-46.759165150899207c0-1.949321815180156,1.580237557549481-3.529559372720541,3.529559372718722-3.529559372720541h64.698593116350821c1.949321815178337,0,3.529559372729636,1.580237557540386,3.529559372729636,3.529559372720541v38.329105879989584Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path655",
    className: "cls-3",
    d: "m193.702844111150625,145.858040887647803v19.733370761989136"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path659",
    className: "cls-2",
    d: "m181.05451504039047,107.883679588638188h-13.191837379930803"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g665"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path667",
    className: "cls-2",
    d: "m184.309215826800937,113.852940275548463h-16.404737806889898"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g669"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path671",
    className: "cls-2",
    d: "m177.303280996460671,119.822200962456918h-9.440603336001004"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g705"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path707",
    className: "cls-3",
    d: "m157.823988180251035,133.898422244006724h71.75771186179918"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m205.55653550767056,99.769768788337387l-13.778757509080606,25.117320790490339c-.37738030221044.687927202759965.120384748999641,1.528732783968735.905024621049961,1.528732783968735h27.557515018150298c.78463987205032,0,1.282404923260401-.84080558120877.905024621040866-1.528732783968735l-13.778757509071511-25.117320790490339c-.391890459470233-.714377793410677-1.418158782618775-.714377793399763-1.810049242089008,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 206.56524463870664,
    y1: 109.84659138242387,
    x2: 206.56524463870664,
    y2: 115.16796151685594
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 206.4809133739618,
    y1: 119.82220096245692,
    x2: 206.4809133739618,
    y2: 120.27950620838055
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 68.87582601436043,
    y: 24.193732093437575,
    width: 47.238613397179506,
    height: 26.13611806810877,
    rx: 3.396584989688563,
    ry: 3.396584989688563
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m116.114439411539934,41.495529686877489h18.032576042200162c1.647799314630902,0,2.983604590079267,1.335805275459279,2.983604590079267,2.983604590099276v13.913956565840635c0,1.647799314629083-1.335805275448365,2.983604590090181-2.983604590079267,2.983604590090181H50.843249972160265c-1.647799314630902,0-2.983604590099276-1.335805275461098-2.983604590099276-2.983604590090181v-13.913956565840635c0-1.647799314639997,1.335805275468374-2.983604590099276,2.983604590099276-2.983604590099276h18.032576042200162"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 36.4095619812706,
    y: 46.3932990451176,
    width: 11.45008340079039,
    height: 10.196312727799523
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.131276737271168,41.495529686877489h11.907980050473778c.2043770088369,0,.370305209618593.165928200781693.370305209618593.370305209618593v19.792780311885927c0,2.904818558600873-2.35834411986405,5.26316267846493-5.26316267846493,5.26316267846493h-2.122265136261234c-2.904818545650297,0-5.263162655000123-2.358344109349829-5.263162655000123-5.263162655000123v-19.792780335335408c0-.204377008845356.165928200788557-.370305209633919.370305209633916-.370305209633919Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 30.523114063260437,
    y1: 23.516129032406752,
    x2: 30.523114063260437,
    y2: 41.49552968687749
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 18.32401361437951,
    y1: 31.21176379690769,
    x2: 42.91132468587057,
    y2: 31.21176379690769
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 137.13062004381936,
    y: 46.3932990451176,
    width: 11.4500834008104,
    height: 10.196312727799523,
    transform: "translate(285.711323488449125 102.982910818034711) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m153.843866098145156,41.495529686877489h2.122265132438258c2.904818555925544,0,5.263162673617558,2.35834411769202,5.263162673617558,5.263162673617558v19.792780316453289c0,.204377008991443-.16592820090716.370305209898603-.370305209898618.370305209898603h-11.907980065341576c-.204377008940867,0-.370305209806986-.165928200866105-.370305209806986-.370305209806972v-19.792780311171107c0-2.904818558891428,2.358344120099929-5.263162678991371,5.263162678991364-5.263162678991371Z",
    transform: "translate(309.809997373950978 108.417307429142198) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 154.46715136261992,
    y1: 23.516129032406752,
    x2: 154.46715136261992,
    y2: 41.49552968687749
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 166.66625181150084,
    y1: 31.21176379690769,
    x2: 142.0789407400298,
    y2: 31.21176379690769
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m73.623862892589386,61.376695432907582h37.74253964070158v6.654643155439771c0,1.289385034879004-1.046817057211385,2.336202092090389-2.336202092090389,2.336202092090389h-33.070135456520802c-1.289385034879004,0-2.336202092090389-1.046817057211385-2.336202092090389-2.336202092090389v-6.654643155439771h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m102.325966986019921,70.367641563578218c-.699481075060248,4.802406002769203-4.834441879669612,8.490633074539801-9.830834273079745,8.490633074539801-4.996401550799419,0-9.131368355150698-3.688240591371141-9.83083811905999-8.490659480150498"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 21.220329320155543,
    y: 166.28812036866202,
    width: 210.4556570651248,
    height: 14.38929898617971,
    rx: 5.987483057220964,
    ry: 5.987483057220964
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m55.805794985970351,147.234098009337686c1.069167949250186-2.947211251381304,7.791257207880335-18.986872031300663,25.601370964799571-12.952672051669651.245162304090627.08306282545891.386598287759625.346342478789666.3152671775606.595171458278855-.858448486740599,2.994582031689788-6.618439571650015,19.902732974700484-25.621243561930896,12.981928092000089-.252570220329289-.091985857188774-.387062146199241-.371741583880066-.295394580429274-.624427498609293Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m55.748118329429417,147.234098009337686c-1.069167949248367-2.947211251381304-7.791257207860326-18.986872031300663-25.601370964788657-12.952672051669651-.245162304090627.08306282545891-.386598287761444.346342478789666-.315267177571513.595171458278855.858448486740599,2.994582031689788,6.618439571660929,19.902732974700484,25.62124356194181,12.981928092000089.252570220338384-.091985857188774.387062146208336-.371741583880066.29539458041836-.624427498609293Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 55.74811832942942,
    y1: 147.23409800933769,
    x2: 55.74811832942942,
    y2: 166.28812035918781
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m114.636348262660249,147.234098009337686c1.069167949250186-2.947211251381304,7.791257207880335-18.986872031300663,25.601370964808666-12.952672051669651.245162304070618.08306282545891.38659828775053.346342478789666.315267177551505.595171458278855-.858448486729685,2.994582031689788-6.618439571650015,19.902732974700484-25.621243561930896,12.981928092000089-.252570220329289-.091985857188774-.387062146199241-.371741583880066-.295394580429274-.624427498609293Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m114.578671606130229,147.234098009337686c-1.069167949250186-2.947211251381304-7.79125720787124-18.986872031300663-25.601370964810485-12.952672051669651-.245162304068799.08306282545891-.38659828775053.346342478789666-.315267177549686.595171458278855.858448486729685,2.994582031689788,6.61843957165911,19.902732974700484,25.621243561930896,12.981928092000089.252570220318376-.091985857188774.387062146199241-.371741583880066.295394580429274-.624427498609293Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 114.57867160613023,
    y1: 147.23409800933769,
    x2: 114.57867160613023,
    y2: 166.28812035918781
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo01);
export default __webpack_public_path__ + "static/media/logo01.cb90f365346ac38ee77472fa4e75e172.svg";
export { ForwardRef as ReactComponent };